/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Edit_BtnInputs */

const vi_customer_edit_btn = /** @type {(inputs: Customer_Edit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉnh sửa`)
};

/**

* @param {Customer_Edit_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_edit_btn = /** @type {((inputs?: Customer_Edit_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Edit_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_edit_btn(inputs)
});